/* eslint-disable */
import { UserAgentApplication } from 'msal';
import Config from '@/shared/constants/config';

export default class AuthService {
  constructor() {
    this.userAgentApp = new UserAgentApplication({
      auth: {
        clientId: Config.B2C.CLIENT_ID,
        authority: Config.B2C.AUTHORITY,
        postLogoutRedirectUri: Config.B2C.POST_LOGOUT_REDIRECT_URI,
        navigateToLoginRequestUrl: Config.B2C.NAVIGATE_TO_LOGIN_REQUEST_URL,
        validateAuthority: Config.B2C.VALIDATE_AUTHORITY,
        policyReset:  Config.B2C.RESET_POLICY
      },
      cache: {
        cacheLocation: 'localStorage',
        storeAuthStateInCookie: true,
        postLogoutRedirectUri: Config.B2C.POST_LOGOUT_REDIRECT_URI,
        navigateToLoginRequestUrl: Config.B2C.NAVIGATE_TO_LOGIN_REQUEST_URL,
        validateAuthority: Config.B2C.VALIDATE_AUTHORITY,
        policyReset:  Config.B2C.RESET_POLICY
      }
    });

    this.userAgentApp.handleRedirectCallback(
      tokenReceived => {
        console.debug('Id token received');
      },
      errorReceived => {
        console.error('Token error: ' + JSON.stringify(errorReceived, null, 2));
        if (errorReceived) {
          if (errorReceived.errorMessage.indexOf('AADB2C90118') >= 0) {
            this.userAgentApp.authority = Config.B2C.RESET_POLICY;
            this.userAgentApp.loginRedirect(Config.B2C.POST_LOGOUT_REDIRECT_URI);
            this.login();
          }
        }
      }
    );
  }

  login() {
    this.userAgentApp.loginRedirect();
  }

  logout() {
    localStorage.removeItem('accessToken');
    this.userAgentApp._user = null;
    this.userAgentApp.logout();
  }

  getUser() {
    return this.userAgentApp.getAccount();
  }

  acquireToken() {
    return this.userAgentApp
      .acquireTokenSilent({ scopes: Config.B2C.B2C_SCOPES })
      .then(({ accessToken }) => {
        localStorage.setItem('accessToken', accessToken);
        return accessToken;
      })
      .catch(err => {
        if (err.errorCode === 'interaction_required') {
          return this.userAgentApp.acquireTokenRedirect({
            scopes: Config.B2C.B2C_SCOPES
          });
          // .acquireTokenPopup()
          // .then(response => {
          //   console.log('access token received');
          //   // get access token from response
          //   // response.accessToken
          //   return response.accessToken;
          // })
          // .catch(err => {
          //   console.log('access token failed');
          //   // handle error
          // });
        }
        return Promise.reject(err);
      });
  }

  isAdmin() {
    const user = this.getUser();
    if (user != null) {
      if (
        user.hasOwnProperty('idToken') &&
        user.idToken.hasOwnProperty('extension_internal_customer')
      ) {
        return user.idToken.extension_internal_customer;
      }
    }
    return false;
  }

  getCustomerNumber() {
    const user = this.getUser();
    if (user != null) {
      if (
        user.hasOwnProperty('idToken') &&
        user.idToken.hasOwnProperty('extension_employer_customer_nr')
      ) {
        return user.idToken.extension_employer_customer_nr;
      }
    }
    return null;
  }
}
